import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { AddIconButton } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    display: 'flex'
  }
}));

const UploadResumeButton = ({ onClick, disabled, hasAttachment }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AddIconButton
        onClick={onClick}
        disabled={disabled}
        data-qe-id="addFileOrUrl"
      >
        <FormattedMessage
          id={hasAttachment ? 'resumeCard.replace' : 'resumeCard.resume'}
        />
      </AddIconButton>
    </div>
  );
};

UploadResumeButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hasAttachment: PropTypes.bool
};

export default UploadResumeButton;
